import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import UserLayout from "./UserLayout";

const ProtectedRoute = ({ children }) => {
  const [isValid, setIsValid] = useState(null);

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  };

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('auth_token');
      //const token = getCookie('auth_token');
      if (!token) {
        setIsValid(false);
        return;
      }

      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/verify-auth`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (response.ok) {
          setIsValid(true);
        } else {
          localStorage.removeItem('auth_token');
          setIsValid(false);
        }
      } catch (err) {
        setIsValid(false);
      }
    };

    checkAuth();
  }, []);

  if (isValid === null) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 10 }}>
        <CircularProgress color="warning" />
      </Box>
    );
  }

  if (!isValid) return <Navigate to="/login" />;

  return (
    <UserLayout>
      {children}
    </UserLayout>
  );
};

export default ProtectedRoute;
